export default "__VITE_ASSET__BqSlOJtC__"